<template>
  <v-dialog v-model="dialog" persistent max-width="320">
    <!-- 결재 모달 다이얼로그 -->
    <v-card class="application-dialog">
      <v-card-title class="d-block title-header text-center">결재</v-card-title>
      <v-card-text class="text-body">
        <div class="text-center desc">반려 하시겠습니까?</div>
        <v-textarea
          v-model="rejectReason"
          outlined
          name="input-7-4"
          label="반려 의견을 작성하실 수 있습니다."
          value=""
          solo
          class="mt-5 shadow-none"
          hide-details
          rows="3"
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="bt-line">
        <v-btn text @click="closeModalCustom()" height="56">
          <span class="primary--text">아니오</span>
        </v-btn>
        <v-btn
          text
          @click="$emit('reject', rejectReason)"
          height="56"
          class="divider"
        >
          <span class="blue--text">네</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import dialogMixin from '@/mixins/dialogMixin.js';

export default {
  mixins: [dialogMixin],
  data() {
    return {
      rejectReason: '',
      modalName: 'reject_reason',
    };
  },
  methods: {
    closeModalCustom() {
      this.rejectReason = '';
      this.closeModal();
    },
  },
};
</script>
<style scoped></style>
